import React, { useState } from "react";
import { Button, Group, Text, Table } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";

const displayValue = (value) => {
  const text = String(value ?? "").trim();
  return text || "--";
};

const userName = (user) => {
  if (!user || typeof user !== "object") return "--";
  return displayValue(user.name || user.cname || user.aliasName);
};

const formatAcknowledgedAt = (value) =>
  value ? moment(value).format("YYYY-MM-DD HH:mm") : "--";

const ApprovalFundAcknowledgementList = ({ form }) => {
  const [api] = useServerApi();
  const [downloading, setDownloading] = useState(false);
  const acknowledgements = (form?.values?.acknowledgements ?? []).filter(
    (item) => item?.approved
  );
  const listId = form?.values?._id;
  const listCode = form?.values?.code;

  const downloadReport = async () => {
    if (!listId) return;
    setDownloading(true);
    try {
      const fileName = listCode
        ? `approved-fund-acknowledgement-${listCode}.xlsx`
        : "approved-fund-acknowledgement.xlsx";
      await api.ApprovalFundList.exportAcknowledgements(listId, fileName);
    } catch (error) {
      showNotification({
        color: "red",
        title: "Acknowledgement report",
        message: error?.message || "Failed to download acknowledgement report",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Group position="right" mb="sm">
        <Button
          size="xs"
          variant="light"
          loading={downloading}
          disabled={!listId}
          onClick={downloadReport}
        >
          Download report
        </Button>
      </Group>
      {!acknowledgements.length ? (
        <Text size="sm" color="dimmed">
          No users have acknowledged this list yet.
        </Text>
      ) : (
        <Table striped highlightOnHover withBorder>
          <thead>
            <tr>
              <th>Staff ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Acknowledged at</th>
            </tr>
          </thead>
          <tbody>
            {acknowledgements.map((item, index) => (
              <tr key={item._id ?? item.user?._id ?? index}>
                <td>{displayValue(item.user?.staffId)}</td>
                <td>{userName(item.user)}</td>
                <td>{displayValue(item.user?.email)}</td>
                <td>{formatAcknowledgedAt(item.passedAt)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ApprovalFundAcknowledgementList;
